export default {
    transform() {
        return (data) => {
            const practice = JSON.parse(data)
            const locations = practice.locations.map((location) => {
                location.practiceId = practice.id
                location.practiceName = practice.name
                return location
            })
            const mainLocation = {
                id: 0,
                name: 'Main',
                practiceId: practice.id,
                practiceName: practice.name,
                address: practice.address,
                city: practice.city,
                state: practice.state,
                zip: practice.zip,
                isAvailabilitySet: practice.isAvailabilitySet,
            }
            locations.unshift(mainLocation)
            return locations
        }
    },
}
